import { render, staticRenderFns } from "./AccionDescargarXml.vue?vue&type=template&id=4049037e&scoped=true&"
import script from "./AccionDescargarXml.vue?vue&type=script&lang=js&"
export * from "./AccionDescargarXml.vue?vue&type=script&lang=js&"
import style0 from "./AccionDescargarXml.vue?vue&type=style&index=0&id=4049037e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4049037e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4049037e')) {
      api.createRecord('4049037e', component.options)
    } else {
      api.reload('4049037e', component.options)
    }
    module.hot.accept("./AccionDescargarXml.vue?vue&type=template&id=4049037e&scoped=true&", function () {
      api.rerender('4049037e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/dte/componentes/acciones/AccionDescargarXml.vue"
export default component.exports